var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChargeFromPvAndGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282,
    height: 197.023,
    viewBox: "0 0 282 197.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7449",
    "data-name": "Group 7449",
    transform: "translate(-14144 -8733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8315",
    "data-name": "Group 8315",
    transform: "translate(18059 30474.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8312",
    "data-name": "Group 8312",
    transform: "translate(375 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(-4058 -21620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "#fff",
    stroke: "#01b4de",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(30.301 6.78) rotate(47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M7.338,32.1l-.073-9.9h5.029l.073,9.9Zm7.192-7.667V16.608h5.029v7.824ZM0,24.431V16.608H5.029v7.824Zm7.265-4.47V12.137h5.029v7.824Zm7.265-5.588V6.549h5.029v7.824ZM0,14.373V6.549H5.029v7.824ZM7.265,9.9,7.192,0h5.029l.073,9.9Z",
    transform: "translate(0 0.863)",
    fill: "#01b4de"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8309",
    "data-name": "Group 8309",
    transform: "translate(-3799 -21594.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy_3",
    "data-name": "Oval Copy 3",
    transform: "translate(0 0.404)",
    fill: "#fff",
    stroke: "#f37320",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "consumed_Icon",
    "data-name": "consumed Icon",
    d: "M12.177,26.158H4.585V13.835H0L15.259,0,30.517,13.835H25.932V26.158H18.34V16.934H12.177Z",
    transform: "translate(10 10)",
    fill: "#f37320"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7297",
    "data-name": "Path 7297",
    d: "M-3876.291-21604.662v41.27s-1.191,6.553,9.614,6.59,74.348,0,74.348,0",
    transform: "translate(-15.465 -10.002)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    d: "M-3792.369-21604.662v41.27s1.191,6.553-9.613,6.59-74.348,0-74.348,0",
    transform: "translate(134.125 -10.002)",
    fill: "none",
    stroke: "#01b4de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8313",
    "data-name": "Group 8313",
    transform: "translate(-12 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    transform: "translate(-3903 -21665)",
    fill: "#fff",
    stroke: "#6b7073",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tower_1_copy",
    "data-name": "tower (1) copy",
    transform: "translate(-3890.136 -21653.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path",
    d: "M23.463,8.145a.809.809,0,0,0,.809-.809V4.1c0-.023-.011-.042-.013-.064a.808.808,0,0,0-.8-.745h-8.4l-.324-1.672H16.99A.809.809,0,0,0,16.99,0H7.282a.809.809,0,1,0,0,1.618H9.531L9.207,3.29H.809a.809.809,0,0,0-.8.745C.011,4.057,0,4.076,0,4.1V7.336a.809.809,0,0,0,1.618,0V5.294L8.274,7.957,7.913,9.763H.809A.831.831,0,0,0,0,10.572v3.236a.809.809,0,0,0,1.618,0V11.881l5.3,2.651c.012.006.026,0,.038.009l-.459,2.3L3.463,26H2.427a.809.809,0,1,0,0,1.618H21.845a.809.809,0,0,0,0-1.618H20.81l-3.035-9.16-.459-2.3c.012-.005.026,0,.038-.009l5.3-2.651v1.927a.809.809,0,0,0,1.618,0V10.572c0-.025-.012-.046-.014-.07a.808.808,0,0,0-.8-.739h-7.1L16,7.957,22.656,5.3V7.336a.809.809,0,0,0,.807.809Z",
    fill: "#6b7073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-2",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M.234,0h1.38l.234,1.208H0Z",
    transform: "translate(11.212 1.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-3",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M2.783,1.169H0L.234,0H2.55Z",
    transform: "translate(10.744 4.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-4",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M0,0H2.8L2.592,1.037Z",
    transform: "translate(5.274 4.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-5",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M0,0H2.423L2.2,1.1Z",
    transform: "translate(4.425 11.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-6",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M2.1,0,4.2,2.1H0Z",
    transform: "translate(10.04 24.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-7",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M2.1,2.1,0,0H4.193Z",
    transform: "translate(10.04 18.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-8",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M5.589,1.169H0L.234,0H5.356Z",
    transform: "translate(9.341 14.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-9",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M0,1.169.234,0H4.42l.234,1.169Z",
    transform: "translate(9.809 11.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-10",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M1.783,0,4.208,2.425,1.285,5.387H0Z",
    transform: "translate(5.621 21.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-11",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M2.923,5.387,0,2.425,2.425,0,4.208,5.387Z",
    transform: "translate(14.443 21.06)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-12",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M2.423,0,.22,1.1,0,0Z",
    transform: "translate(17.425 11.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-13",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M0,1.169.234,0H3.485l.234,1.169Z",
    transform: "translate(10.277 8.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_x3C_Group_x3E__1_-path-14",
    "data-name": "_x3C_Group_x3E__1_-path",
    d: "M.207,1.037,0,0H2.8Z",
    transform: "translate(16.199 4.983)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7299",
    "data-name": "Path 7299",
    d: "M-3876.139-21672.539v-27.455s-1.281-9.412,11.293-9.666,208.079.012,208.079.012,10.959.688,10.829,11.416,0,25.578,0,25.578",
    transform: "translate(-12 -10)",
    fill: "none",
    stroke: "#01b4de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_182",
    "data-name": "Polygon 182",
    transform: "translate(-3803.795 -21571.289) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M7.29,7.5H1.71a.5.5,0,0,1-.436-.745l2.79-4.96a.5.5,0,0,1,.872,0l2.79,4.96A.5.5,0,0,1,7.29,7.5Z",
    fill: "#6b7073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M4.5,2.04h0L1.71,7H7.29L4.5,2.04m0-1a.99.99,0,0,1,.872.51l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51l2.79-4.96A.99.99,0,0,1,4.5,1.04Z",
    fill: "#6b7073"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7986",
    "data-name": "Group 7986",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7293",
    "data-name": "Path 7293",
    d: "M-3669.228-21640H-3716.1",
    transform: "translate(-22.014 -9)",
    fill: "none",
    stroke: "#01b4de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_183",
    "data-name": "Polygon 183",
    transform: "translate(-3743.205 -21644.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M7.29,7.5H1.71a.5.5,0,0,1-.436-.745l2.79-4.96a.5.5,0,0,1,.872,0l2.79,4.96A.5.5,0,0,1,7.29,7.5Z",
    fill: "#01b4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M4.5,2.04h0L1.71,7H7.29L4.5,2.04m0-1a.99.99,0,0,1,.872.51l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51l2.79-4.96A.99.99,0,0,1,4.5,1.04Z",
    fill: "#01b4de"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_184",
    "data-name": "Polygon 184",
    transform: "translate(-3744.205 -21562.289) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M7.29,7.5H1.71a.5.5,0,0,1-.436-.745l2.79-4.96a.5.5,0,0,1,.872,0l2.79,4.96A.5.5,0,0,1,7.29,7.5Z",
    fill: "#01b4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M4.5,2.04h0L1.71,7H7.29L4.5,2.04m0-1a.99.99,0,0,1,.872.51l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51l2.79-4.96A.99.99,0,0,1,4.5,1.04Z",
    fill: "#01b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_185",
    "data-name": "Polygon 185",
    transform: "translate(-3883.676 -21681) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M7.29,7.5H1.71a.5.5,0,0,1-.436-.745l2.79-4.96a.5.5,0,0,1,.872,0l2.79,4.96A.5.5,0,0,1,7.29,7.5Z",
    fill: "#01b4de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M4.5,2.04h0L1.71,7H7.29L4.5,2.04m0-1a.99.99,0,0,1,.872.51l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51l2.79-4.96A.99.99,0,0,1,4.5,1.04Z",
    fill: "#01b4de"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8314",
    "data-name": "Group 8314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8310",
    "data-name": "Group 8310",
    transform: "translate(327.176 -107.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-4126.176 -21566.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy_3-2",
    "data-name": "Oval Copy 3",
    fill: "#fff",
    stroke: "#5fd10b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(10.826 12.377)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 28.051,
    height: 20.197,
    rx: 2,
    transform: "translate(0 5.049)",
    fill: "#7acf38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_",
    "data-name": "\\uF217",
    d: "M6.154,2.761a.51.51,0,0,1,.384.164.559.559,0,0,1,0,.777.51.51,0,0,1-.384.164H3.9V6.092a.5.5,0,0,1-.166.38.573.573,0,0,1-.784,0,.5.5,0,0,1-.166-.38V3.866H.54A.51.51,0,0,1,.157,3.7a.559.559,0,0,1,0-.777A.51.51,0,0,1,.54,2.761H2.789V.535a.5.5,0,0,1,.166-.38.573.573,0,0,1,.784,0A.5.5,0,0,1,3.9.535V2.761Z",
    transform: "translate(3.825 12.623)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    "data-name": "\\uF208",
    d: "M6.154.074a.51.51,0,0,1,.384.164.543.543,0,0,1,.157.388.543.543,0,0,1-.157.388.51.51,0,0,1-.384.164H.54a.51.51,0,0,1-.384-.164A.543.543,0,0,1,0,.626.543.543,0,0,1,.157.237.51.51,0,0,1,.54.074Z",
    transform: "translate(16.575 15.153)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_Copy_5",
    "data-name": "Rectangle Copy 5",
    d: "M2,0H3.1a2,2,0,0,1,2,2V3.787H0V2A2,2,0,0,1,2,0Z",
    transform: "translate(3.825)",
    fill: "#7acf38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_Copy_6",
    "data-name": "Rectangle Copy 6",
    d: "M2,0H3.1a2,2,0,0,1,2,2V3.787H0V2A2,2,0,0,1,2,0Z",
    transform: "translate(19.125)",
    fill: "#7acf38"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    "data-name": "Group 4",
    transform: "translate(-4126.176 -21566.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy_3-3",
    "data-name": "Oval Copy 3",
    fill: "#fff",
    stroke: "#5fd10b",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9-2",
    "data-name": "Group 9",
    transform: "translate(10.826 12.377)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 28.051,
    height: 20.197,
    rx: 2,
    transform: "translate(0 5.049)",
    fill: "#7acf38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    "data-name": "\\uF217",
    d: "M6.154,2.761a.51.51,0,0,1,.384.164.559.559,0,0,1,0,.777.51.51,0,0,1-.384.164H3.9V6.092a.5.5,0,0,1-.166.38.573.573,0,0,1-.784,0,.5.5,0,0,1-.166-.38V3.866H.54A.51.51,0,0,1,.157,3.7a.559.559,0,0,1,0-.777A.51.51,0,0,1,.54,2.761H2.789V.535a.5.5,0,0,1,.166-.38.573.573,0,0,1,.784,0A.5.5,0,0,1,3.9.535V2.761Z",
    transform: "translate(3.825 12.623)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4",
    "data-name": "\\uF208",
    d: "M6.154.074a.51.51,0,0,1,.384.164.543.543,0,0,1,.157.388.543.543,0,0,1-.157.388.51.51,0,0,1-.384.164H.54a.51.51,0,0,1-.384-.164A.543.543,0,0,1,0,.626.543.543,0,0,1,.157.237.51.51,0,0,1,.54.074Z",
    transform: "translate(16.575 15.153)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_Copy_5-2",
    "data-name": "Rectangle Copy 5",
    d: "M2,0H3.1a2,2,0,0,1,2,2V3.787H0V2A2,2,0,0,1,2,0Z",
    transform: "translate(3.825)",
    fill: "#7acf38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_Copy_6-2",
    "data-name": "Rectangle Copy 6",
    d: "M2,0H3.1a2,2,0,0,1,2,2V3.787H0V2A2,2,0,0,1,2,0Z",
    transform: "translate(19.125)",
    fill: "#7acf38"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Oval_Copy_3-4",
    "data-name": "Oval Copy 3",
    transform: "translate(-3805 -21680)",
    fill: "none",
    stroke: "#5fd10b",
    strokeWidth: 6,
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 28,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7985",
    "data-name": "Group 7985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7293-2",
    "data-name": "Path 7293",
    d: "M-3669.228-21640H-3716.1",
    transform: "translate(-7528.533 -43289.32) rotate(180)",
    fill: "none",
    stroke: "#6b7073",
    strokeWidth: 1,
    strokeDasharray: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_183-2",
    "data-name": "Polygon 183",
    transform: "translate(-3807.344 -21653.822) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3655-2",
    "data-name": "Path 3655",
    d: "M7.29,7.5H1.71a.5.5,0,0,1-.436-.745l2.79-4.96a.5.5,0,0,1,.872,0l2.79,4.96A.5.5,0,0,1,7.29,7.5Z",
    fill: "#6b7073"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656-2",
    "data-name": "Path 3656",
    d: "M4.5,2.04h0L1.71,7H7.29L4.5,2.04m0-1a.99.99,0,0,1,.872.51l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51l2.79-4.96A.99.99,0,0,1,4.5,1.04Z",
    fill: "#6b7073"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908",
    transform: "translate(7674 2911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_247",
    "data-name": "Ellipse 247",
    transform: "translate(6607 5822)",
    fill: "#fff",
    stroke: "#01b4de",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3-2",
    "data-name": 3,
    transform: "translate(6613 5835)",
    fill: "#01b4de",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6909",
    "data-name": "Group 6909",
    transform: "translate(7729 2981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_247-2",
    "data-name": "Ellipse 247",
    transform: "translate(6607 5822)",
    fill: "#fff",
    stroke: "#01b4de",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(6613 5835)",
    fill: "#01b4de",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6910",
    "data-name": "Group 6910",
    transform: "translate(7747 3063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_247-3",
    "data-name": "Ellipse 247",
    transform: "translate(6607 5822)",
    fill: "#fff",
    stroke: "#01b4de",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2-2",
    "data-name": 2,
    transform: "translate(6613 5835)",
    fill: "#01b4de",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911",
    transform: "translate(7587 3063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_247-4",
    "data-name": "Ellipse 247",
    transform: "translate(6607 5822)",
    fill: "#fff",
    stroke: "#6b7073",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4-2",
    "data-name": 4,
    transform: "translate(6612 5835)",
    fill: "#6b7073",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7987",
    "data-name": "Group 7987",
    transform: "translate(7607 2981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_247-5",
    "data-name": "Ellipse 247",
    transform: "translate(6607 5822)",
    fill: "#fff",
    stroke: "#6b7073",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.625,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4-3",
    "data-name": 4,
    transform: "translate(6612 5835)",
    fill: "#6b7073",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeFromPvAndGrid);
export default __webpack_public_path__ + "static/media/chargeFromPvAndGrid.5a700d1cd1c0cfd3fee658147f347180.svg";
export { ForwardRef as ReactComponent };